import React, { forwardRef } from 'react';

export const InvisibleContainer = forwardRef<HTMLDivElement, { children: React.ReactNode }>(({ children }, ref) => (
  <div data-test='invisible-container' ref={ref} style={{ position: 'absolute', top: -9999, opacity: 0 }}>
    {children}
  </div>
));
